/**
 * `useLayoutEffect` that does not show warning when server-side rendering, see Alex Reardon's article for more info.
 * https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */
export { default as useIsomorphicLayoutEffect } from 'use-isomorphic-layout-effect';